(function ($) {
	'use strict';

	//** Autocomplete */
	// Query completion with summary text.
	$('.js-typeahead-query-long').qc({
		datasets: {
			organic: {
				collection: 'safework-rebuild',
				profile: 'autocomplete',
				program: 'https://srws-search.clients.squiz.net/s/suggest.json',
				show: '10',
				template: {

					suggestion: function (context) {
						var itemResult = '<a href="%URL%" class="search-suggest-result-large__container"><p class="search-suggest-result-large__title">%TITLE%</p><p class="search-suggest-result-large__summary">%SUMMARY%</p></a>';

						itemResult = itemResult.replace('%URL%', String(context.label.displayUrl));
						itemResult = itemResult.replace('%TITLE%', String(context.label.title));

						// Check for the preferred "search" metadata description.
						if (context.label.metaData.desc !== undefined && context.label.metaData.desc !== '') {

							itemResult = itemResult.replace('%SUMMARY%', String(context.label.metaData.desc));
						} else {

							// Try for the alternate search description.
							if (context.label.metaData.desc2 !== undefined && context.label.metaData.desc2 !== '') {

								itemResult = itemResult.replace('%SUMMARY%', String(context.label.metaData.desc2));
							} else {

								// Fallback to empty summary.
								itemResult = itemResult.replace('%SUMMARY%', '');
							}
						}

						return itemResult;
					}
				}
			}
		},
		length: 3,
		typeahead: {
			events: {
				select: function (event, suggestion) {
					// override select action to not submit form on selection
					// Redirect the user to the suggested page
					window.location.href = suggestion.label.displayUrl;
				}
			}
		},
		interactionLog: ''
	});

	// Standard query completion.
	$('.js-typeahead-query-standard').qc({
		datasets: {
			mentalhealth: {
				collection: 'safework-mental-health-web',
				profile: '',
				program: 'https://srws-search.clients.squiz.net/s/suggest.json',
				show: '5',
				template: {

					suggestion: function (context) {
						var itemQuery = String(context.label);
						var itemResult = `<div class="search-suggest-result-large__container"><span>${itemQuery}</span><svg class="svg-icon icon-arrow-right" xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"><path fill="#8BCF90" fill-rule="evenodd" d="M11.5 6.5c0 .266-.102.523-.289.71l-5.086 5.087c-.187.18-.445.289-.71.289-.267 0-.517-.11-.704-.29l-.586-.585c-.187-.188-.297-.445-.297-.711 0-.266.11-.523.297-.71L6.415 8h-5.5C.351 8 0 7.531 0 7V6c0-.531.352-1 .914-1h5.5L4.125 2.703c-.187-.18-.297-.437-.297-.703 0-.266.11-.523.297-.703L4.711.71c.187-.188.437-.297.703-.297.266 0 .524.11.711.297l5.086 5.086c.187.18.289.437.289.703z"/></svg></div>`;
						itemResult = itemResult.replace('%LABEL%', String(context.label));
						return itemResult;
					},
					header: function () {
						return '<h3>Mental Health at work</h3>';
					}
				}
			},
			safework: {
				collection: 'safework-rebuild',
				profile: '',
				program: 'https://srws-search.clients.squiz.net/s/suggest.json',
				show: '5',
				template: {

					suggestion: function (context) {
						var itemQuery = String(context.label);
						var itemResult = `<div class="search-suggest-result-large__container"><span>${itemQuery}</span><svg class="svg-icon icon-arrow-external" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><g fill="#4F9989" fill-rule="evenodd"><path d="M14.096 3.904c.17.17.27.4.27.64l-.014 6.513c-.005.235-.1.47-.271.64-.17.17-.4.261-.636.267l-.75.001c-.24 0-.475-.094-.645-.264-.17-.17-.264-.404-.264-.644l.006-2.932-5.343 5.343c-.361.361-.886.287-1.226-.052l-.639-.64c-.34-.339-.413-.864-.052-1.225l5.343-5.343H6.938c-.235.006-.47-.088-.64-.258-.17-.17-.264-.405-.258-.64l.001-.75c0-.24.091-.47.262-.64.17-.171.405-.267.645-.267l6.513-.013c.236-.006.465.094.635.264z"/><path fill-rule="nonzero" d="M.917 3c.47 0 .857.344.91.788l.006.104v11.324h12.25c.47 0 .858.345.91.788l.007.104c0 .457-.354.834-.81.886l-.107.006H.917c-.47 0-.858-.344-.91-.788L0 16.108V3.892C0 3.399.41 3 .917 3z"/></g></svg></div>`; 
						// <a href="https://www.safework.nsw.gov.au/search?query=${itemQuery}">${itemQuery}</a>
						itemResult = itemResult.replace('%LABEL%', String(context.label));

						return itemResult;
					},
					header: function () {
						return '<h3>Safework NSW</h3>';
					}
				}
			}
		},
		length: 3,
		// typeahead: {
		// 	// events: {
		// 	// 	select: function (event, suggestion) {
		// 	// 		// override select action to not submit form on selection
		// 	// 		// Redirect the user to the suggested page
		// 	// 		window.location.href = suggestion.label.displayUrl;
		// 	// 	}
		// 	// }
		// },
		interactionLog: ''
	}).bind("typeahead:selected", function(event, suggestion) {
		currentDatasetValue = suggestion.dataset;
		formAction(currentDatasetValue); // set form action url with the selected item's dataset
		// console.log("selected", suggestion.dataset);
	});

	// window.onbeforeunload = function (e) {
	// 	console.log(e);
	// 	return true;
	// }

	// SWMHAW3-11: implementation of dual datasets

	// find dataset name from the classname of the dataset block generated
	const getDatasetName = (datasetClassname) => {
		const regex = /dataset-(([^\s]*?)+)/; 
		const datasetName = regex.exec(datasetClassname)
		return datasetName[1];
	}

	// targeting header search form
	var $headerSearchForm = $('.quick-search__form');
	var $headerSearchFormInput = $headerSearchForm.find('.js-typeahead-query-standard');

	// saving the dataset block in a variable
	const $datasetBlock = $headerSearchForm.find('.tt-dataset');
	
	// saving dataset names generated in dropdown classes in variables
	var mentalhealthDatasetName = '';
	var safeworkDatasetName = '';

	$datasetBlock.each(function (e) {
		var $current = $(this);
		var getClassname = $current.attr('class');
		if (e === 0) { // By default the first one is "mentalhealth"
			mentalhealthDatasetName = getDatasetName(getClassname);
			//set class active by default to mentalhealth automplete suggestions
			$current.attr('data-content', mentalhealthDatasetName).addClass("active");
		}
		if (e === 1) {
			safeworkDatasetName = getDatasetName(getClassname);
			$current.attr('data-content', safeworkDatasetName);
		}
	})

	// defining dataset default value
	var currentDatasetValue = mentalhealthDatasetName;

	// autocomplete dropdown block for header search form
	var $headerSearchFormAutocomplete = $headerSearchForm.find('.tt-menu');
	
	const displayHeaders = () => {
		const mentalhealthTabText = "Mental Health at work"
		const safeworkTabText = "Safework NSW"
		var $mentalHealthTab = $('<span>', {'text': mentalhealthTabText, 'class': 'search-collection-name active', 'data-tab': mentalhealthDatasetName});
		var $safeworkTabTab = $('<span>', {'text': safeworkTabText, 'class': 'search-collection-name', 'data-tab': safeworkDatasetName});
		var $div = $('<div>', {'class': 'search-collection'});
		$div.append($mentalHealthTab);
		$div.append($safeworkTabTab);
		$headerSearchFormAutocomplete.prepend($div);
	}

	// displaying the two collection names in the dropdown
	displayHeaders();

	const formAction = (dataset) => { // set form action dynamically on dataset value
		var actionURL = '';
		
		if (dataset === mentalhealthDatasetName) {
			if (typeof mentalHealthSearchFormAction !== 'undefined' && mentalHealthSearchFormAction !== undefined && mentalHealthSearchFormAction !== null && mentalHealthSearchFormAction !== "") { 
				// this variable value is defined in Matrix #385748
				actionURL = mentalHealthSearchFormAction;
			} else {
				actionURL = "https://www.mentalhealthatwork.nsw.gov.au/search-results"; // for testing
			}
		} else if (dataset === safeworkDatasetName) {
			if (typeof safeworkSearchFormAction !== 'undefined' && safeworkSearchFormAction !== undefined && safeworkSearchFormAction !== null && safeworkSearchFormAction !== "") {
				// this variable value is defined in Matrix #385748
				actionURL = safeworkSearchFormAction
			} else {
				actionURL = "https://www.safework.nsw.gov.au/search"; // for testing
			}
		} else {
			return;
		}
		$headerSearchForm.attr("action", actionURL);
	}

	// set default form action
	formAction(currentDatasetValue);

	// header search form: click listener when autocomplete dropdown item selected
	$headerSearchForm.on('click', '.search-suggest-result-large__container', function(event) {
		event.preventDefault();
		$headerSearchFormInput.val($(this).text());
		$headerSearchForm.submit(); // submit form on selection of rendered items
	});

	const $searchCollectionBlock = $('.search-collection');

	// click event to add/remove 'active' class on the dataset name tab
	$searchCollectionBlock.on('click', '.search-collection-name', function() {
		const $datasetClicked = $(this);
        const datasetTabName = $datasetClicked.attr('data-tab');
		if (!$datasetClicked.hasClass('active')) {
			$searchCollectionBlock.find('.active').removeClass('active');
			$datasetClicked.addClass('active');
			const $datasetItems = $(`.tt-dataset[data-content="${datasetTabName}"]`);
			$datasetBlock.removeClass('active');
			$datasetItems.addClass('active');
			currentDatasetValue = datasetTabName;
			formAction(currentDatasetValue);
		}
	});

	// Search-results page form query completion.
	$('.js-typeahead-query').qc({
		datasets: {
			mentalhealth: {
				collection: 'safework-mental-health-web',
				profile: '',
				program: 'https://srws-search.clients.squiz.net/s/suggest.json',
				show: '5',
				template: {

					suggestion: function (context) {
						var itemResult = '<div class="search-suggest-result-large__container">%LABEL%</div>';

						itemResult = itemResult.replace('%LABEL%', String(context.label));

						return itemResult;
					}
				}
			}
		},
		length: 3,
		// typeahead: {
		// 	// events: {
		// 	// 	select: function (event, suggestion) {
		// 	// 		// override select action to not submit form on selection
		// 	// 		// Redirect the user to the suggested page
		// 	// 		window.location.href = suggestion.label.displayUrl;
		// 	// 	}
		// 	// }
		// },
		interactionLog: ''
	});

}(jQuery));